module.exports = __webpack_public_path__ + "static/media/Artboard11.651d1a8c.png";